module.exports = ".hidden {\n  opacity: 0;\n  z-index: -1; }\n"